import { render, staticRenderFns } from "./DialogWall.vue?vue&type=template&id=3da39e30&scoped=true&"
import script from "./DialogWall.vue?vue&type=script&lang=js&"
export * from "./DialogWall.vue?vue&type=script&lang=js&"
import style0 from "./DialogWall.vue?vue&type=style&index=0&id=3da39e30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da39e30",
  null
  
)

export default component.exports